export const MOS_THRESHOLDS = {
  /** Below this MOS the connection is considered "bad" — lower bound of poor. */
  poor: 2,
  fair: 3,
  good: 4,
} as const;
